import { useState, forwardRef, useImperativeHandle, useRef, useEffect, useContext } from 'react';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import Utils from '@utils/utils'
import { RightOutlined } from '@ant-design/icons';
import InvitationRecordModal from './InvitationRecordModal';
import API from '@api/api';
import { message } from 'antd';
import { AppContext } from '@utils/AppContext';


const InvitationEventModal = forwardRef((props, ref) => {
    const { globalUser, globalActivity} = useContext(AppContext);
    const invitationRecordRef = useRef();

    useImperativeHandle(ref, () => ({
        open: () => setInvitationEventVisible(true),
        close: () => setInvitationEventVisible(false),
    }))

    const [InvitationEventVisible, setInvitationEventVisible] = useState(false)
    const [tooltipVisible, setTooltipVisible] = useState(false)

    const handleOpenInvitationRecord = () => {
        invitationRecordRef.current?.open();
    };

    const [currentInviteCount, setCurrentInviteCount] = useState(49);
    const [InfoData, setInfoData] = useState({});

    useEffect(() => {
        if(!InvitationEventVisible) return
        activityLadderInfo()
    }, [InvitationEventVisible])

    const activityLadderInfo = () => {
        if (!localStorage.getItem('token')) return
        API.activityLadderInfo({
        }).then((res) => {
            if (res.code == 0) {
                setCurrentInviteCount(res.data?.inviteNum)
                setInfoData(res.data)
            }
        })
    }

    const levelConfig = [
        { level: 1, reward: '400奖励', rewardBeans: '400虹豆', target: 3, label: '累计邀请3人' },
        { level: 2, reward: '额外800奖励', rewardBeans: '800虹豆', target: 5, label: '累计邀请5人' },
        { level: 3, reward: '额外1,500奖励', rewardBeans: '1,500虹豆', target: 10, label: '累计邀请10人' },
        { level: 4, reward: '额外2,000奖励', rewardBeans: '2,000虹豆', target: 20, label: '累计邀请20人' },
        { level: 5, reward: '额外5,000奖励', rewardBeans: '5,000虹豆', target: 50, label: '累计邀请50人' },
        { level: 6, reward: '额外10,000奖励', rewardBeans: '10,000虹豆', target: 100, label: '累计邀请100人' },
        { level: 'Max', reward: '额外50,000奖励', rewardBeans: '50,000虹豆', target: 500, label: '累计邀请500人' },
    ]

    const calculateTotalProgress = () => {
        // 每段的百分比
        const totalSegments = levelConfig.length - 1;
        const segmentWidth = 100 / totalSegments;

        const count = currentInviteCount;
        if(count <= 3) return 0

        // 找处于哪一段
        let segmentIndex = 0;

        for (let i = 0; i < levelConfig.length; i++) {
            if (count >= levelConfig[i].target) {
                segmentIndex = i;
            } else {
                break;
            }
        }

        if (segmentIndex === levelConfig.length - 1) {
            return 100;
        }

        const prevTarget = segmentIndex > 0 ? levelConfig[segmentIndex].target : 0;
        const nextTarget = levelConfig[segmentIndex + 1].target;

        const segmentProgress = (count - prevTarget) / (nextTarget - prevTarget);

        return segmentIndex * segmentWidth + segmentProgress * segmentWidth;
    };

    const copyLink = (link) => {
        if (!link) return;
        const fullLink = link;

        // 如果 clipboard API 可用
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(fullLink)
                .then(() => {
                    message.success('复制成功');
                })
                .catch(err => {
                    console.error('Clipboard error:', err);
                    message.error('复制失败，请手动复制');
                });
        } else {
            // 兼容旧浏览器
            const textarea = document.createElement('textarea');
            textarea.value = fullLink;
            textarea.style.position = 'fixed';
            textarea.style.top = '-9999px';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();

            try {
                const success = document.execCommand('copy');
                if (success) {
                    message.success('复制成功');
                } else {
                    message.warning('复制失败，请手动复制');
                }
            } catch (err) {
                console.error('Fallback copy error:', err);
                message.error('复制失败，请手动复制');
            }
            document.body.removeChild(textarea);
        }
    }

    return <>
        <PSAIModal
            title={null}
            maxWidth="1300px"
            footer={null}
            open={InvitationEventVisible}
            maskClosable={false}
            onCancel={() => setInvitationEventVisible(false)}
            zIndex={1002}
        >
            <div className={styles.InvitationEventModal}>
                <div className={styles.MainLogo}></div>
                <div className={styles.MainTitle}></div>
                <p className={styles.ActivityPeriod}>活动有效期 {globalActivity?.ACTIVITY_240711?.beginAt?.format('YYYY年MM月DD日')} — {globalActivity?.ACTIVITY_240711?.endAt?.format('YYYY年MM月DD日')}</p>
                <div className={styles.ActionContainer}>
                    <input
                        type="text"
                        className={styles.InviteLinkInput}
                        value={Utils.getInviteLink(globalUser?.invitationCode)}
                        readOnly
                    />
                    <button className={styles.ButtonRight} onClick={() => copyLink(Utils.getInviteLink(globalUser?.invitationCode))}>复制邀请链接</button>
                </div>
                <div className={styles.InvitationEventWrap}>
                    <div className={styles.Header}>
                        <span>邀请越多，奖励越多</span>
                        <span onClick={handleOpenInvitationRecord}>邀请记录 <RightOutlined /></span>
                    </div>
                    <div className={styles.Header2}>
                        <div className={styles.Header2Left}>
                            <p>Lv.{InfoData?.level || 0}</p>
                            <p>当前等级</p>
                        </div>
                        <div className={styles.Header2Right}>
                            <div className={styles.Header2RightItem}>
                                <p>{InfoData?.totalAmount || 0}</p>
                                <p>已获虹豆</p>
                            </div>
                            <div className={styles.Header2RightItem}>
                                <p>{InfoData?.inviteNum || 0}</p>
                                <p>已邀请人数</p>
                            </div>
                            <div className={styles.Header2RightItem}>
                                <p>{InfoData?.orderNum || 0}</p>
                                <p>已购买好友数</p>
                            </div>
                        </div>
                    </div>
                    <p className={styles.Header3}>- 活动规则 -</p>
                    <div className={styles.Header4Container}>
                        <div className={styles.progressBarLayer}>
                            <div className={styles.progressBackground}></div>
                            <div
                                className={styles.progressFillWrapper}
                                style={{
                                    width: `${calculateTotalProgress()}%`
                                }}
                                onMouseEnter={() => setTooltipVisible(true)}
                                onMouseLeave={() => setTooltipVisible(false)}
                            >
                                <div className={styles.progressFill}></div>
                            </div>
                        </div>
                        <div className={styles.Header4}>
                            {levelConfig.map((config, index) => (
                                <div key={index} className={styles.Header4Item}>
                                    <p className={styles.reward}>{config.reward}</p>
                                    <div className={styles.iconWrapper}>
                                        <p className={`${styles.icon} ${styles[`icon${index + 1}`]}`}></p>
                                    </div>
                                    <p className={styles.level}>Lv. {config.level}</p>
                                    <p className={styles.target}>{config.label}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles.Header5}>
                        <div className={styles.Header5Left}>
                            <img src={Utils.qrcodeSales} alt="扫码联系我们" />
                            <p>请联系客服</p>
                        </div>
                        <div className={styles.Header5Right}>
                            <p>1、双重福利：好友通过您的链接注册，Ta可获200虹豆（有效期1个月）；同时您累计1个邀请人数，解锁阶梯奖励；</p>
                            <p>2、奖励发放：≤50人奖励自动到账；≥100人奖励您可选择发放至个人或企业账户，请联系客服选择并于次日查收奖励；</p>
                            <p>3、特别奖励：被邀请好友购买任意套餐，您均可额外获得300虹豆（有效期1年）</p>
                            <p>4、有效期说明：所有邀请奖励有效期1个月，特别奖励有效期1年</p>
                            <p>5、活动最终解释权归ArcSoft虹软所有</p>
                        </div>
                    </div>
                </div>
            </div>
        </PSAIModal>
        <InvitationRecordModal ref={invitationRecordRef} />
    </>
})
export default InvitationEventModal
